export default "__VITE_ASSET__4d538ed3__"